// export const logout = ( state ) => {
// }

export const setInputs = (state, inputs) => {
    state.inputs = inputs
}

export const setInputsPaginated = (state, inputsPaginatedData) => {
    state.inputsPaginatedData = inputsPaginatedData
}

export const setInputDetail = (state, input) => {
    state.input = input
}

export const setInputIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setInputsUnplacedData = (state, inputsUnplacedData) => {
    state.inputsUnplacedData = inputsUnplacedData
}

export const setIsLoadingInputsUnplaceData = (state, isLoadingInputsUnplaceData) => {
    state.isLoadingInputsUnplaceData = isLoadingInputsUnplaceData
}